import { NewRelicConfig } from './models/new-relic-config.model';
import { CanonicalEnvironmentName } from '../common/genesys-cloud-config';

const defaultNewRelicBeacon = 'bam-cell.nr-data.net';
export const newRelicConfig: NewRelicConfig = {
  defaults: {
    distributedTracing: false,
    cookiesEnabled: true,
    beacon: defaultNewRelicBeacon,
    errorBeacon: defaultNewRelicBeacon,
    ajaxDenyList: [
      defaultNewRelicBeacon
    ],
    sa: 1
  },
  [CanonicalEnvironmentName.Dev]: {
    accountID: '864720',
    trustKey: '1787700',
    agentID: '1385943812',
    licenseKey: 'cbd1bbd32a',
    applicationID: '1385943812'
  },
  [CanonicalEnvironmentName.Test]: {
    accountID: '864721',
    trustKey: '1787700',
    agentID: '1385943814',
    licenseKey: '49e6134ee2',
    applicationID: '1385943814'
  },
  [CanonicalEnvironmentName.Prod]: {
    accountID: '811457',
    trustKey: '1787700',
    agentID: '1385943818',
    licenseKey: '7a5b0de38e',
    applicationID: '1385943818'
  }
};
